module.exports = __webpack_public_path__ + "img/going-out.cbfa8b1f.svg";